export default __webpack_public_path__ + "static/OneoftheAmericaslastkingdoms-e911f91c7d2e081a81b5bcfde667c072.jpg";